import { Component, OnInit } from '@angular/core';
import { TrackerService } from 'src/app/shared/util/tracker.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fiscal-guide',
  templateUrl: './fiscal-guide.component.html',
  styleUrls: ['./fiscal-guide.component.scss'],
})
export class FiscalGuideComponent implements OnInit {
  assistantHref = '';
  openTopicIndex: number | null = 0;

  readonly topicIndexes = [1, 2, 3, 4, 5];
  readonly taxIndexes = [1, 2, 3, 4];

  constructor(private trackerService: TrackerService) {}

  ngOnInit(): void {
    this.trackerService.trackPageViews();
    this.assistantHref = environment.assistantApp;
  }

  topicTitleKey(index: number): string {
    return `FISCAL_GUIDE.TOPIC_${index}_TITLE`;
  }

  topicTextKey(index: number): string {
    return `FISCAL_GUIDE.TOPIC_${index}_TEXT`;
  }

  taxTitleKey(index: number): string {
    return `FISCAL_GUIDE.TAX_${index}_TITLE`;
  }

  taxTextKey(index: number): string {
    return `FISCAL_GUIDE.TAX_${index}_TEXT`;
  }

  toggleTopic(index: number): void {
    this.openTopicIndex = this.openTopicIndex === index ? null : index;
  }
}
